import React, { useEffect } from 'react';

// --- CSS STYLES FOR THE ANIMATION ---
// We include this directly in the file for easy management.
const styles = `
  .destinations-ticker-section {
    padding: 4rem 0;
    overflow: hidden; /* This is crucial to hide the overflowing cards */
    background-color: #f8f9fa;
  }

  .destinations-ticker-track {
    display: flex;
    /* The animation will move the track from right to left */
    animation: ticker-scroll 40s linear infinite;
  }

  .destinations-ticker-section:hover .destinations-ticker-track {
    animation-play-state: paused; /* Pause the animation on hover */
  }

  /* Keyframe animation for the scrolling effect */
  @keyframes ticker-scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      /* Move the track to the left by the width of one set of cards */
      transform: translateX(-50%);
    }
  }

  /* --- Destination Card Styles --- */
  .destination-card {
    flex: 0 0 auto; /* Prevent cards from shrinking or growing */
    width: 280px; /* Fixed width for each card */
    height: 380px;
    margin: 0 1rem;
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    color: white;
    transition: transform 0.3s ease;
  }

  .destination-card:hover {
    transform: translateY(-10px); /* Lift the card up on hover */
  }

  .destination-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .destination-card .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
    padding: 1.5rem;
  }

  .destination-card .title {
    font-size: 1.5rem;
    font-weight: bold;
  }

  .destination-card .package-count {
    font-size: 0.9rem;
    opacity: 0.8;
  }
`;

// --- The Card Component ---
const DestinationCard = ({ image, name, packageCount }) => (
  <div className="destination-card shadow-lg">
    <img src={image} alt={name} />
    <div className="overlay d-flex flex-column justify-content-end">
      <h3 className="title mb-1">{name}</h3>
      <p className="package-count mb-0">{packageCount} Packages</p>
    </div>
  </div>
);

// --- The Main Section Component ---
const Destinations1 = () => {
  // Static data for the destinations.
  const destinations = [
    { image: 'https://images.pexels.com/photos/21014/pexels-photo.jpg', name: 'Santorini', packageCount: 8 },
    { image: 'https://images.pexels.com/photos/2404949/pexels-photo-2404949.jpeg', name: 'Kyoto', packageCount: 5 },
    { image: 'https://images.pexels.com/photos/2161449/pexels-photo-2161449.jpeg', name: 'Swiss Alps', packageCount: 12 },
    { image: 'https://images.pexels.com/photos/3225528/pexels-photo-3225528.jpeg', name: 'Bali', packageCount: 15 },
    { image: 'https://images.pexels.com/photos/1586942/pexels-photo-1586942.jpeg', name: 'Sri Lanka', packageCount: 7 },
    { image: 'https://images.pexels.com/photos/1618269/pexels-photo-1618269.jpeg', name: 'Thailand', packageCount: 18 },
  ];
  
  // We duplicate the array to create the seamless looping effect
  const duplicatedDestinations = [...destinations, ...destinations];

  // Effect to inject the styles into the document head
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = styles;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  return (
    <section className="destinations-ticker-section">
      {/* Section Header */}
      <div className="container text-center mb-5">
        <h2 className="display-5 fw-bold">Popular Destinations</h2>
        <p className="lead text-muted">Find your next dream vacation</p>
      </div>
      
      {/* The Ticker/Carousel */}
      <div className="destinations-ticker-track">
        {duplicatedDestinations.map((dest, index) => (
          <DestinationCard key={index} {...dest} />
        ))}
      </div>
    </section>
  );
};

export default Destinations1;